module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-loading",
    class: [_vm.computedSize ? 'rt-loading-' + _vm.computedSize : '']
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    class: [_vm.showMask ? 'rt-loading-mask' : 'rt-loading-hide-mask']
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "rt-fade-ease-in-out"
    },
    on: {
      "after-leave": _vm.handleAfterLeave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "rt-loading-spinner"
  }, [(_vm.computedType === 1 || !_vm.computedType) ? _c('span', {
    staticClass: "rt-loading-dot"
  }, [_c('i'), _vm._v(" "), _c('i'), _vm._v(" "), _c('i')]) : _c('span', {
    staticClass: "rt-loading-circle"
  }), _vm._v(" "), (_vm.textColor) ? _c('p', {
    staticClass: "rt-loading-text",
    class: [_vm.textColor ? 'rt-loading-text-' + _vm.textColor : '']
  }, [_vm._v("\n        " + _vm._s(_vm.text) + "\n      ")]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29e0f5c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/loading/src/loading.vue
// module id = 2045
// module chunks = 228